export default __webpack_public_path__ + "static/media/expandArrow.4ca13fc2.svg";